/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Related_KickerInputs */

const en_road_dude_related_kicker = /** @type {(inputs: Road_Dude_Related_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ANOTHER AI VIDEO TREND`)
};

const zh_road_dude_related_kicker = /** @type {(inputs: Road_Dude_Related_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另一个 AI 视频玩法`)
};

/**
* | output |
* | --- |
* | "ANOTHER AI VIDEO TREND" |
*
* @param {Road_Dude_Related_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_related_kicker = /** @type {((inputs?: Road_Dude_Related_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Related_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_related_kicker(inputs)
	return zh_road_dude_related_kicker(inputs)
});
export { road_dude_related_kicker as "road_dude.related.kicker" }